module.exports = __webpack_public_path__ + "static/media/sims_dashboardsidenav_background.80a1d86b.png";